import logo from './logo.svg';
import Navbar from './component/Navbar';
import HeroSection from './component/HeroSection';
import Features from "./component/Features";
import AboutSection from "./component/AboutSection";
import RegisterSection from "./component/RegisterSection";
import Hero from './component/Hero';
import Faq from './component/Faq';
import BackToTop from './component/BackToTop';
import Footer from './component/Footer';
import FloatingEnquiry from './component/FloatingEnquiry';

import "./App.css";

function App() {
  return (

    <div className="app-container">
      <Navbar />
      <Hero />
      {/* <HeroSection /> */}
      <AboutSection />
      <Features />
      <RegisterSection />
      <Faq></Faq>
      <Footer></Footer>
      <FloatingEnquiry></FloatingEnquiry>
      <BackToTop></BackToTop>


    </div>
  );
}

export default App;
